import { render, staticRenderFns } from "./AsideBottomMenu.vue?vue&type=template&id=0639f40d&scoped=true"
import script from "./AsideBottomMenu.vue?vue&type=script&lang=js"
export * from "./AsideBottomMenu.vue?vue&type=script&lang=js"
import style0 from "./AsideBottomMenu.vue?vue&type=style&index=0&id=0639f40d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639f40d",
  null
  
)

export default component.exports